import React from "react";
import "./style.css";



const MatchTimeline = ({ playerStats, match }) => {
  const goalEvents = [];

  playerStats
    .filter((p) => p.number_of_goals > 0)
    .forEach((player) => {
      const minutes = player.goals_minutes.split(" ");
      minutes.forEach((minute, index) => {
        goalEvents.push({
          id: `${player.player.id}-${minute}-${index}`,
          minute,
          playerName: player.player.player_name || "İsimsiz",
          teamName: player.team.team_name,
          isFirstTeam: player.team.team_name === match.first_team_name,
        });
      });
    });

  return (
    <div className="timeline-vertical-container">
      <h3 className="timeline-title">Maç Zaman Çizelgesi</h3>
      <div className="timeline-list">
        {goalEvents.map((event) => (
          <div
            key={event.id}
            className={`timeline-item ${event.isFirstTeam ? "left" : "right"}`}
          >
            <div className="icon">⚽</div>
            <div className="info">
              <span className="player-name">{event.playerName}</span>
              <span className="minute">({event.minute}')</span>
              <span className="team-name"> - {event.teamName}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MatchTimeline;
